export default "__VITE_ASSET__IAEbmHas__"